import { STATIC_URL } from 'constants/data'

const imgPath = {
  play: `${STATIC_URL}/cards/play.svg#svgView(viewBox(0, 0, 47, 52))`,
  iconDate: `${STATIC_URL}/cards/icon_date.svg`,
  iconDateBlack: `${STATIC_URL}/cards/icon_date_black.svg`,
  iconTime: `${STATIC_URL}/cards/icon_time.svg`,
  iconTimeBlack: `${STATIC_URL}/cards/icon_time_black.svg`,
  iconEye: `${STATIC_URL}/cards/icon_eye.svg`,
  iconEyeGrey: `${STATIC_URL}/cards/icon_eye_grey.svg`,
  iconLike: `${STATIC_URL}/cards/icon_like.svg`,
  iconLikeGrey: `${STATIC_URL}/cards/icon_like_grey.svg`,
  iconCategory: `${STATIC_URL}/cards/icon_category.svg`,
  iconComment: `${STATIC_URL}/comment/icon_comment_grey.svg`,
}

const ImageData = {
  play: {
    src: imgPath.play,
    width: 47,
    height: 52,
    alt: 'Смотреть видео',
    unoptimized: true,
  },
  time: {
    src: imgPath.iconTime,
    width: 16,
    height: 16,
    alt: 'Длительность просмотра',
    unoptimized: true,
  },
  time_black: {
    src: imgPath.iconTimeBlack,
    width: 15,
    height: 15,
    alt: 'Длительность просмотра',
    unoptimized: true,
  },
  category: {
    src: imgPath.iconCategory,
    width: 14,
    height: 14,
    alt: 'Категория',
    unoptimized: true,
  },
  date_black: {
    src: imgPath.iconDateBlack,
    width: 15,
    height: 15,
    alt: 'Дата публикации',
    unoptimized: true,
  },
  date: {
    src: imgPath.iconDate,
    width: 14,
    height: 16,
    alt: 'Дата публикации',
    unoptimized: true,
  },
  views: {
    src: imgPath.iconEye,
    width: 16,
    height: 16,
    alt: 'Количество просмотров',
    unoptimized: true,
  },
  views_grey: {
    src: imgPath.iconEyeGrey,
    width: 18,
    height: 16,
    alt: 'Количество просмотров',
    unoptimized: true,
  },
  like: {
    src: imgPath.iconLike,
    width: 16,
    height: 16,
    alt: 'Количество лайков',
    unoptimized: true,
  },
  like_grey: {
    src: imgPath.iconLikeGrey,
    width: 16,
    height: 16,
    alt: 'Количество лайков',
    unoptimized: true,
  },
  comment: {
    src: imgPath.iconComment,
    width: 16,
    height: 16,
    alt: 'Количество комментариев',
    unoptimized: true,
  },
}

export { ImageData }
